module.exports = __webpack_public_path__ + "img/flip-second.a0b18e5a.svg";